import { Component, OnInit, HostListener } from "@angular/core";
// import { LoaderService } from "./core/services/loader.service";
import { ThemeService } from "./core/services/theme.service";
import { TranslateService } from "@ngx-translate/core";
// import { UserDataService } from "./core/services/user-data.service";
// import { CookieService } from "ngx-cookie-service";
//import * as $ from "jquery";
import { ReuseTabService } from "./core/reuse-tab";
import { Router } from "@angular/router";
import { LocalStorageService } from "./core/services/local-storage.service";
import { CommonService } from "./core/services/common.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  //showLoader: boolean = false;
  theme: string;

  constructor(
    // private loaderService: LoaderService,
    private themeService: ThemeService,
    translate: TranslateService,
    // private userDataService: UserDataService,
    private router: Router,
    private reuseTabService: ReuseTabService,
    private localStorageService: LocalStorageService,
    public commonService : CommonService,

  ) {
    let theme = this.localStorageService.getItem("selected-theme");
    if (theme != null && theme.length > 0) {
      this.theme = theme;
      this.themeService.selectTheme(theme);
    } else {
      this.theme = "dark-theme";
    }

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang("VN");

    let language = this.localStorageService.getItem("language");
    if (language != null && language.length > 0) {
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(language);
    } else {
      this.localStorageService.setItem("language", "VN");
    }

  }

  ngOnInit() {
    // this.loaderService.status.subscribe((val: boolean) => {
    //   this.showLoader = val;
    // });
    this.themeService.theme.subscribe((val: string) => {
      this.theme = val;
    });
  }

  @HostListener("window:keydown", ["$event"]) onKeyDown(e: KeyboardEvent) {
    if (!e.ctrlKey && e.altKey && e.keyCode == 39) {
      e.preventDefault();
      e.stopPropagation();
      // Ctrl + right
      let index = this.reuseTabService.items.findIndex(
        (e) => e.url == this.reuseTabService.curUrl
      );
      if (index < this.reuseTabService.items.length - 1 && index != -1)
        this.router.navigateByUrl(this.reuseTabService.items[index + 1].url);
    } else if (!e.ctrlKey && e.altKey && e.keyCode == 37) {
      e.preventDefault();
      e.stopPropagation();
      //Ctrl + Left
      let index = this.reuseTabService.items.findIndex(
        (e) => e.url == this.reuseTabService.curUrl
      );
      if (index > 0)
        this.router.navigateByUrl(this.reuseTabService.items[index - 1].url);
      else if (index == -1) {
        this.router.navigateByUrl(this.reuseTabService.items[this.reuseTabService.items.length - 1].url);
      }
    } else if (e.ctrlKey && e.keyCode == 81) {
      e.preventDefault();
      e.stopPropagation();
      //Ctrl + Q to quit
      if (this.reuseTabService.items.length > 1)
        this.reuseTabService.close(this.reuseTabService.curUrl);
    }
    else if (e.altKey && e.keyCode == 81) {
      e.preventDefault();
      e.stopPropagation();
      //alt + Q to quit all
      this.reuseTabService.clear();
    }
  }
  @HostListener('window:unload', ['$event'])
    unloadHandler(event) {
  }

  @HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    $event.returnValue = "Are you sure?";
  }
}
